// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1355d","content":"_0c8e5"};